var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPodd = function SvgIcPodd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.75,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 4.75,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#FFF",
    d: "M6 17.861c0-1.41 2.034-5.361 3-5.361s3 3.952 3 5.361c0 1.47-1.363 2.639-3 2.639s-3-1.17-3-2.639z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#FFF",
    d: "M6 17.861c0-1.41 2.034-5.361 3-5.361s3 3.952 3 5.361c0 1.47-1.363 2.639-3 2.639s-3-1.17-3-2.639z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 3,
    fill: "currentColor",
    stroke: "#FFF"
  }))));
};
export default SvgIcPodd;